export default {
  question: 'Have a question? We\'ll get back to you shortly.',
  submit: 'Submit',
  submissionConfirmationMessage: {
    Title: 'Submitted',
    Subtitle: 'We\'ll get back to you as soon as possible',
  },
};
